<template>
  <div class="login-wrap">
    <!-- 顶部导航栏 -->
    <header class="login-header">
      <div class="logo-bar">
        <img
          src="@/assets/login/icon_logo.png"
          alt="新致软件"
          class="logo-img"
        />
        <span class="logo-text">新致软件</span>
      </div>
      <div class="header-right">
        <a
          class="link-home"
          href="https://newtouch.com/#/"
          target="_blank"
          rel="noopener noreferrer"
          >官网首页</a
        >
      </div>
    </header>

    <!-- 主体左右分栏 -->
    <main class="login-main">
      <!-- 左侧3D插画区域 -->
      <section class="login-left">
        <div class="illustration-box"></div>
      </section>

      <!-- 右侧 销售联系方式 区域 -->
      <section class="login-right">
        <div class="form-container">
          <div class="brand-title">
            <img
              src="@/assets/login/logo-img2.png"
              alt="新致软件"
              class="logo-img2"
            />
            <h2 class="cn-brand">新知智法.AI法律助手</h2>
            <p class="brand-desc">欢迎咨询产品套餐与企业定制方案</p>
          </div>

          <!-- 销售联系方式 -->
          <div class="contact-block">
            <h3 class="contact-title">销售联系方式</h3>
            <div class="contact-item">
              <span class="label">咨询热线：</span>
              <span class="text">027-59978396</span>
            </div>
            <div class="contact-item">
              <span class="label">商务微信：</span>
              <span class="text">newtouchopen</span>
            </div>
            <div class="contact-item">
              <span class="label">咨询邮箱：</span>
              <span class="text">contact@tntlinking.com</span>
            </div>
            <div class="contact-item">
              <span class="label">工作时间：</span>
              <span class="text">周一至周五 9:00 - 18:00</span>
            </div>
          </div>

          <div class="contact-tip">
            如需企业私有化部署、定制功能、批量采购套餐，欢迎联系销售获取专属报价与产品演示。
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
// 原登录逻辑全部移除，不需要登录接口、表单、校验等代码
import { onMounted } from "vue";

onMounted(() => {
  // 可在此埋点、页面统计
});
</script>

<style scoped lang="less">
// 全局主题变量
:root {
  --primary-blue: #1677ff;
  --light-bg: #f7faff;
  --text-dark: #1a1a1a;
  --text-gray: #8c8c8c;
  --border-light: #e6edf7;
  --white: #ffffff;
}

.login-wrap {
  width: 100vw;
  height: 100vh;
  background: var(--white);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 顶部导航栏
.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  flex-shrink: 0;

  .logo-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    .logo-img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
    .logo-text {
      font-size: 16px;
      font-weight: 500;
      color: var(--text-dark);
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 24px;
    .link-home {
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }
  }
}

// 主体左右布局
.login-main {
  flex: 1;
  display: grid;
  grid-template-columns: 60% 40%;
  overflow: hidden;
  background-image: url("@/assets/login/icon_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

// 左侧插画区域
.login-left {
  display: flex;
  align-items: center;
  justify-content: center;
  .illustration-box {
    width: 85%;
    height: 85%;
  }
}

// 右侧联系板块区域
.login-right {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  background-image: url("@/assets/login/icon_bg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  .form-container {
    width: 100%;
    max-width: 420px;
  }
}

// 品牌标题区
.brand-title {
  margin-bottom: 40px;
  .cn-brand {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #000000;
  }
  .brand-desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #929aa6;
    line-height: 25px;
    margin-bottom: 40px;
  }
}

.logo-img2 {
  width: 200px;
  // height: 26px;
  margin: 12px 0;
}

// 销售联系方式模块
.contact-block {
  background: #f5fafe;
  border-radius: 12px;
  padding: 28px 24px;
  margin-bottom: 24px;
  .contact-title {
    font-size: 20px;
    font-weight: 600;
    color: #142649;
    margin: 0 0 24px;
  }
  .contact-item {
    display: flex;
    margin-bottom: 16px;
    line-height: 28px;
    .label {
      width: 96px;
      font-size: 15px;
      color: #62728b;
    }
    .text {
      flex: 1;
      font-size: 15px;
      color: #142649;
    }
  }
}

// 底部说明文字
.contact-tip {
  font-size: 14px;
  color: #62728b;
  line-height: 24px;
}
</style>
